module.exports = __webpack_public_path__ + "img/tcdc-m-logo.6fe1e5a9.png";